import { FC } from 'react';
import { mesCurto } from '@/utils/painelFormat';

interface Props {
  /** Rótulo longo do mês (`Setembro/2026`). */
  label: string;
  /** Período já formatado (`16/08–15/09`). */
  periodo: string;
}

/**
 * Conteúdo do chip de mês: `Set/26 · 16/08–15/09`. O período fica dentro do chip
 * porque as abas de produção usam o mês 16→15 e a DRE o mês civil; sem ele,
 * "Set/26" parece o mesmo mês nas duas e não é.
 */
const RotuloMes: FC<Props> = ({ label, periodo }) => (
  <>
    {mesCurto(label)}
    <span className="font-normal tabular-nums">· {periodo}</span>
  </>
);

export default RotuloMes;
